<template>
  <vx-card title="Distritos">
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="districts"
    >
      <template slot="thead">
        <vs-th>Nombre</vs-th>
        <vs-th>Estado</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ tr.DistNom }}</span>
            </vs-td>

            <vs-td>
              <custom-checkbox
                  :value="tr.estado"
                  textoCaso1="Visible"
                  textoCaso0="Oculto"
                  @change="updateStatus('estado', $event, tr)"
                ></custom-checkbox>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import GetDistritos from "@/apollo/queries/otros/GetDistritos.gql";
import updateEstadoDistrito  from "@/apollo/mutations/distritos/updateEstadoDistrito.gql";

export default {
  data() {
    return {
      itemsPerPage: 10,
      loadingAction: false,
      loading: false,
      districts: []
    };
  },
  mounted() {
    this.getDistricts();
  },
  methods: {
    getDistricts() {
      this.districts = [];

      let ProCode = 128; // Lima

      this.$apollo
        .query({
          query: GetDistritos,
          fetchPolicy: 'no-cache',
          variables: {
            ProCode,
          },
        })
        .then((response) => {
          this.districts = response.data.GetDistritos
        });
    },
    updateStatus(type, event, item) {
      let status = event.target.checked === true ? 1 : 0

      let input = {
        "DistCodi": parseInt(item.DistCodi)
      }

      input.estado = parseInt(status)

      this.$apollo.mutate({
        mutation: updateEstadoDistrito,
        variables: {
          input
        }
      })
      .then(() => {
        item.estado = status

        this.$vs.notify({
            title: "Estado actualizado",
            color: "success",
            position: "top-right",
          })
      })
    }
  }
};
</script>

<style lang="scss">
.table-product-img {
  max-width: 100%;
  width: 80px;
}

.table-color {
  width: 30px;
  height: 30px;
}
</style>